import { Modal } from "antd";
import LoadingBig from "../../../assets/images/lottie/loading_big.json";
import Lottie from "lottie-react";
import React from "react";
import "./index.css";

interface IModalClassNames {
  header?: string;
  body?: string;
  footer?: string;
  mask?: string;
  wrapper?: string;
  content?: string;
}

interface ModalStyles {
  header?: React.CSSProperties;
  body?: React.CSSProperties;
  footer?: React.CSSProperties;
  mask?: React.CSSProperties;
  wrapper?: React.CSSProperties;
  content?: React.CSSProperties;
}

interface IProps {
  open: boolean;
  setOpen: Function;
  modalClassNames?: IModalClassNames;
  modalStyles?: ModalStyles;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  cancelBtn?: string | React.ReactNode;
  okBtn?: string | React.ReactNode;
  onCancelClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onOkClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  // cancelLoading?: boolean;
  okLoading?: boolean;
  okLoadingText?: string;
  loaddingIcon?: React.ReactNode;
  btnContainer?: React.ReactNode;
  classNames?: {
    title?: string;
    btnContainer?: string;
    content?: string;
    cancelBtn?: string;
    okBtn?: string;
  };
  styles?: {
    title?: React.CSSProperties;
    btnContainer?: React.CSSProperties;
    content?: React.CSSProperties;
    cancelBtn?: React.CSSProperties;
    okBtn?: React.CSSProperties;
  };
}

const ConfirmModal = ({
  open,
  setOpen,
  modalClassNames,
  modalStyles,
  title,
  content,
  cancelBtn,
  okBtn,
  onCancelClick,
  onOkClick,
  okLoading,
  okLoadingText = "삭제중",
  loaddingIcon,
  btnContainer,
  classNames,
  styles,
}: IProps) => {
  const andtModalClassNames: Required<Omit<IModalClassNames, "btnContainer">> =
  {
    header:
      "" + (modalClassNames?.header ? " " + modalClassNames.header : ""),
    body: "" + (modalClassNames?.body ? " " + modalClassNames.body : ""),
    footer:
      "" + (modalClassNames?.footer ? " " + modalClassNames.footer : ""),
    mask: "" + (modalClassNames?.mask ? " " + modalClassNames.mask : ""),
    wrapper:
      "custom_confirm_modal " +
      (modalClassNames?.wrapper ? " " + modalClassNames.wrapper : ""),
    content:
      "" + (modalClassNames?.content ? " " + modalClassNames.content : ""),
  };
  const andtModalStyles: Required<Omit<ModalStyles, "btnContainer">> = {
    header: {
      ...modalStyles?.header,
    },
    body: {
      ...modalStyles?.body,
    },
    footer: {
      ...modalStyles?.footer,
    },
    mask: {
      ...modalStyles?.mask,
    },
    wrapper: {
      maxWidth: "100%",
      ...modalStyles?.wrapper,
    },
    content: {
      marginInline: "23.5px",
      padding: 0,
      maxWidth: "480px",
      ...modalStyles?.content,
    },
    ...modalStyles,
  };

  const getLoaddingIcon = () => {
    if (React.isValidElement(loaddingIcon)) return loaddingIcon;
    return (
      <Lottie
        style={{ width: 16, height: 16 }}
        animationData={LoadingBig}
        autoplay={true}
      />
    );
  };

  return (
    <>
      <Modal
        classNames={andtModalClassNames}
        centered
        styles={andtModalStyles}
        open={open}
        onCancel={() => setOpen(false)}
        closeIcon={null}
        footer={null}
      >
        {typeof title === "string" ? (
          <div
            className={
              "sub-title/st3 base/black" +
              (classNames?.title ? " " + classNames.title : "")
            }
            style={{
              marginBottom: "8px",
              textAlign: "center",
              ...styles?.title,
            }}
          >
            {title}
          </div>
        ) : (
          React.isValidElement(title) && title
        )}

        {typeof content === "string" ? (
          <div
            className={
              "body/b2 secondary/s800" +
              (classNames?.content ? " " + classNames.content : "")
            }
            style={{
              paddingBottom: "6px",
              marginBottom: "16px",
              textAlign: "center",
              ...styles?.content,
            }}
          >
            {content}
          </div>
        ) : (
          React.isValidElement(content) && content
        )}

        {React.isValidElement(btnContainer) ? (
          btnContainer
        ) : (
          <div
            className={
              "" +
              (classNames?.btnContainer ? " " + classNames.btnContainer : "")
            }
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
              ...styles?.btnContainer,
            }}
          >
            {typeof cancelBtn === "string" ? (
              <div
                className={
                  "body/b2 secondary/s800" +
                  (classNames?.cancelBtn ? " " + classNames.cancelBtn : "")
                }
                style={{
                  width: "100%",
                  textAlign: "center",
                  paddingBlock: "var(--space12)",
                  border: "1px solid var(--secondary-s400, #AEAEAE)",
                  borderRadius: "var(--radius4)",
                  ...styles?.cancelBtn,
                }}
                onClick={onCancelClick}
              >
                {cancelBtn}
              </div>
            ) : (
              React.isValidElement(cancelBtn) && cancelBtn
            )}

            {typeof okBtn === "string" ? (
              <div
                className={
                  `body/b2 ${okLoading ? "secondary/s400" : "base/white"}` +
                  (classNames?.okBtn ? " " + classNames.okBtn : "")
                }
                style={{
                  width: "100%",
                  textAlign: "center",
                  paddingBlock: "var(--space12)",
                  borderRadius: "var(--radius4)",
                  backgroundColor: okLoading
                    ? "var(--secondarys200)"
                    : "var(--baseblack)",
                  ...styles?.okBtn,
                }}
                onClick={onOkClick}
              >
                {okLoading ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    {" "}
                    {okLoadingText} {getLoaddingIcon()}
                  </div>
                ) : (
                  okBtn
                )}
              </div>
            ) : (
              React.isValidElement(okBtn) && okBtn
            )}
          </div>
        )}
      </Modal>
    </>
  );
};

export default ConfirmModal;
